import 'typeface-roboto';
import store from './store';
import { connect } from 'react-redux';
import NewRoutes from './domain/NewRoutes';
import ErrorBoundary from './errorBoundary';
import { getUserInfoByIP } from './utils/consts';
import { Spinner, ScrollToTop } from './component';
import { isTripord } from './utils/consts/general';
import ToastProvider from './contextProvider/ToastProvider';
import {
  LocaleSettingProvider,
  LocaleSettingContext,
} from './utils/consts/localeSetting';
import React, { useEffect, Suspense, useState, useCallback } from 'react';

const RouterProvider = (props) => {
  const [timeZone, setTimeZone] = useState({});

  const configureTimeZone = useCallback(
    (
      timeZone = 'Iran, Theran',
      timeZoneFullName = 'Iran, Tehran (Asia/Tehran)',
      countryCode = 'IR',
    ) => {
      return new Promise((resolve, reject) => {
        try {
          localStorage.setItem('timeZone', JSON.stringify(timeZone));
          localStorage.setItem(
            'timeZoneFullName',
            JSON.stringify(timeZoneFullName),
          );
          setTimeZone((prevState) => {
            if (
              prevState.timeZone !== timeZone ||
              prevState.timeZoneFullName !== timeZoneFullName
            ) {
              return { timeZone, timeZoneFullName, countryCode };
            }
            return prevState;
          });
          resolve({ timeZoneFullName, timeZone, countryCode });
        } catch (error) {
          reject(error);
        }
      });
    },
    [],
  );

  const localStorageTimeZone = JSON.parse(localStorage.getItem('timeZone'));
  const localStorageTimeZoneFullName = JSON.parse(
    localStorage.getItem('timeZoneFullName'),
  );
  const hasLocalStorageTimeZone =
    localStorageTimeZone && localStorageTimeZoneFullName;

  const getResult = async () => {
    const fullTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    await getUserInfoByIP()
      .then((res) => {
        if (res) {
          const timeZone = `${res.countryName || 'Iran'}, ${
            res.city || 'Tehran'
          }`;
          configureTimeZone(
            timeZone,
            `${timeZone} (${fullTimeZone})`,
            res.countryCode,
          );
        } else {
          setTimeZone(
            'Iran, Tehran',
            `Iran, Tehran (Asia/Tehran)`,
            res.countryCode,
          );
        }
      })
      .catch((err) => {
        return null;
      });
  };

  useEffect(() => {
    if (isTripord)
      document.title = 'Airplane ticket - booking ticket | tripord';
    else document.title = 'Airplane ticket - booking ticket | tripsi';
    if (!hasLocalStorageTimeZone) getResult();
  }, []);

  useEffect(() => {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    const TITLE_FA = `بلیط هواپیما - خرید بلیط هواپیما | ${
      isTripord ? 'تریپورد' : 'تریپسی'
    }`;
    const TITLE_EN = `airplane ticket - booking ticket |${
      isTripord ? 'tripord' : 'tripsi'
    } `;

    html.setAttribute('dir', props.direction);
    body.setAttribute('style', `font-family: ${props.fontFamily}; `);
    html.setAttribute('lang', props.name);

    document.title = props.name === 'fa' ? TITLE_FA : TITLE_EN;
  }, [props.language]);
  return (
    <ErrorBoundary>
      <ToastProvider
        AutoClose={5000}
        direction={props.direction}
        position="top"
      >
        <LocaleSettingProvider
          value={{
            timeZone: timeZone.timeZone,
            timeZoneFullName: timeZone.timeZoneFullName,
            setTimeZone: configureTimeZone,
            language: props.language,
            direction: props.direction,
            countryCode: timeZone.countryCode,
          }}
        >
          <div
            className="bg-third-light min-vh-100 "
            style={{
              direction: store.getState().language.direction,
              fontFamily: store.getState().language.fontFamily,
              position: 'relative',
            }}
          >
            <ScrollToTop pathname={window.location.origin}>
              <Suspense fallback={<Spinner />}>
                <NewRoutes />
              </Suspense>
            </ScrollToTop>
          </div>
        </LocaleSettingProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
};
const mapStateToProps = ({ language }) => {
  const { direction, fontFamily, name } = language;
  return { direction, fontFamily, name };
};
export default connect(mapStateToProps)(RouterProvider);
